import React from 'react';
import { compose, lifecycle } from 'recompose';
import { withStoreDetail } from '../../Common/Providers/WithStoreDetail';
import {
  withSubscriptionData,
  addSubscriptionToCart,
} from '../../Common/Providers/SubscriptionApi';
import { showPermanentErrorMsg } from '../../Common/ErrorMsg';
import SubscriptionLogo from '../../Common/SubscriptionLogo';
import TermsAndConditions from '../../Promotion/TermsAndConditions';

const joinNow = (id) => {
  addSubscriptionToCart(id)
    .done((response) => {
      window.location = response.data.redirect_to_cart_url;
    })
    .fail(error => showPermanentErrorMsg(error.responseJSON.errors || 'Error: Pass is no longer available'));
}

const Plans = (props) => {
  const {
    store: {
      currency: {
        symbol = '',
      },
    },
    subscription,
  } = props;

  const plans = subscription && subscription.plans.map((value, index) => {
    return (
      <div className='card mb-3 p-2 pt-3' key={index}>
        <div>
          <div className='col d-flex flex-wrap align-items-center subscription__name'>
            <span className="dashboard__subscription-logo-container--list">
              <SubscriptionLogo height={55}/>
            </span>
            <div dangerouslySetInnerHTML={{ __html: value.label }}></div>
          </div>
        </div>
        <div className='d-lg-flex justify-content-between'>
          <div className='col'>
            <div className='mb-3'>
              <span className='subscription__price'>{symbol}{value.price}</span> {value.period}
            </div>
            <div className='subscription__desc' dangerouslySetInnerHTML={{ __html: value.description }}></div>
            <TermsAndConditions contents={value.term} id={value.id}
                                tncText='*Terms and conditions apply.'/>
          </div>
          <div className='col-auto d-flex flex-column align-items-center pb-3'>
            <button className='btn btn-primary' onClick={() => joinNow(`${value.id}`)}>JOIN NOW</button>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div>
      {plans}
    </div>
  );
}

const enhance = compose(
  withStoreDetail,
  withSubscriptionData,
  lifecycle({
    componentDidMount() {
      if(this.props.shouldCallApi) {
        this.props.handleShown();
        this.didCallApi = true;
      } else {
        this.didCallApi = false;
      }
    },
    componentDidUpdate() {
      if(this.props.shouldCallApi && !this.didCallApi) {
        this.didCallApi = true;
        this.props.handleShown();
      }
    },
  })
)

export default enhance(Plans);
export const undecorated = Plans;



// WEBPACK FOOTER //
// ./src/Account/Subscription/Plans.js